<template>
    <div class="GameMatch">
        <!-- 下拉框选择部分 -->
        <div class="GameMatch_header">
            <div class="font_w font_si">{{PhaseName}}</div>
            <div>
                <el-select v-model="TeamValue" placeholder="请选择" @change="handleChange">
                    <el-option
                    v-for="item in TeamArr"
                    :key="item.TeamID"
                    :label="item.TeamName"
                    :value="item.TeamID"
                    >
                    </el-option>
                </el-select>
            </div>
        </div>
        <!-- tab部分 -->
        <div>
            <el-row>
                <el-button v-for="(i,index) in PhaseArr" :key="index" :class="active == index ? 'activeCLass' : ''" @click="handleGroup(i.PhaseID,index)">{{i.PhaseDes}}</el-button>
                <!-- <el-button>第三阶段-三、四名决赛</el-button>
                <el-button>第三阶段-半决赛</el-button>
                <el-button>第三阶段-冠亚军决赛</el-button> -->
            </el-row>
        </div>
        <!-- 内容部分 -->
        <div class="GameMatch_box">
            <div class="GameMatch_box_data" v-for="(o,index) in RoundArr" :key="index" >
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>{{o.RoundDes}}</span>
                    </div>
                    <div>
                        <el-table
                            :data="o.MatchEntityList"
                            :show-header="false"
                            :row-class-name="TableRowClassName"
                            :header-cell-style="{'text-align':'center'}"
                            :cell-style="{'text-align':'center'}"
                            style="width: 100%"
                            v-if="o.MatchEntityList.length > 0"
                            >
                            <!-- <el-table-column
                                label="轮次"
                                width="70">
                                <template slot-scope="scope">
                                    <div class="">{{scope.row.MatchTime}}</div>
                                </template>
                            </el-table-column> -->
                            <el-table-column
                                label="场序"
                                width="50">
                                <template slot-scope="scope">
                                    <div>{{ scope.row.MatchOrder}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="时间"
                                width="150">
                                <template slot-scope="scope">
                                    <div class="padding_obe">{{ scope.row.MatchDate + ' ' + scope.row.MatchTime}}</div>
                                </template>
                            </el-table-column>
                            
                            <el-table-column
                            label="队伍">
                                <template slot-scope="scope">
                                    <div class="text_c"> {{scope.row.TeamH}}
                                    <span v-if="scope.row.IRMH !='' " :style="{'color':'red'}">{{ scope.row.IRMH }}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column
                            label="213"
                            width="80" >
                                <template >
                                    <div>
                                        头像
                                    </div>
                                </template>
                            </el-table-column> -->
                            <el-table-column
                            label="结果"
                            width="80">
                                <template slot-scope="scope">
                                    <div class="font_w">{{scope.row.ScoreH+' '}} - {{' '+scope.row.ScoreV}}</div>
                                </template>
                            </el-table-column>
                            <!-- <el-table-column
                            label="213"
                            width="80">
                                <template>
                                    <div>
                                        头像
                                    </div>
                                </template>
                            </el-table-column> -->
                            <el-table-column
                            label="队伍"
                            >
                                <template slot-scope="scope">
                                    <div class="text_c">{{scope.row.TeamV}}
                                        <span v-if="scope.row.IRMV !='' " :style="{'color':'red'}">{{ scope.row.IRMV }}</span>
                                    </div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="局分"
                                width="230"
                                >
                                <template slot-scope="scope">
                                    <div :style="{'text-align':'left'}">{{scope.row.DetailPoints}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="总分"
                                width="80"
                                >
                                <template slot-scope="scope">
                                    <div>{{scope.row.TotalPoints}}</div>
                                </template>
                            </el-table-column>
                            <el-table-column
                                label="地点"
                                width="210">
                                <template slot-scope="scope">
                                    <div class="font_s" :style="{'text-align':'left'}">{{ scope.row.Venue}}</div>
                                </template>
                            </el-table-column>
                        
                        </el-table>
                        <el-empty v-else description="暂无数据啦..."></el-empty>
                    </div>
                </el-card>
                
            </div>
        </div>

    </div>
</template>

<script>
import http from '@/assets/js/http.js';
export default {
    data() {
      return {
        options: [{
          value: '选项1',
          label: '黄金糕'
        }, {
          value: '选项2',
          label: '双皮奶'
        }, {
          value: '选项3',
          label: '蚵仔煎'
        }, {
          value: '选项4',
          label: '龙须面'
        }, {
          value: '选项5',
          label: '北京烤鸭'
        }],
        TeamValue: '-1',
        tableData: [{
          date: '2016-05-02',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1518 弄'
        }, {
          date: '2016-05-04',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1517 弄'
        }, {
          date: '2016-05-01',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1519 弄'
        }, {
          date: '2016-05-03',
          name: '王小虎',
          address: '上海市普陀区金沙江路 1516 弄'
        }],
        PhaseID: '',
        PhaseName: '',
        PhaseArr: [],
        RoundArr: [],
        autofocus: true,
        my_data: null,
        active: 0,
        TeamArr: [],
      };
    },
    props:['phase'],
    watch: {
        // PhaseID(newVal,oldVal){
        //     // console.log('这是新值111:',newVal)
        //     // console.log('这是laozh1111i:',oldVal)
        //     // this.GetEventStatHome();//获取首页9大统计数据接口
        // }
        phase(newVal,oldVal){
            // console.log('这是新值111:'+newVal)
            // console.log('这是laozh1111i:'+oldVal)
            this.active = 0;
            this.GetMatchResultList(newVal,this.TeamValue)//获取比赛成绩列表
        },
        $route: { // 亲测有效,我是用来监听query参数变化
            handler(newVal,oldVal) {
                // this.id = this.$route.query.id;
                // this.getDetail();
                // console.log('这是新值:',newVal)
                // console.log('这是laozhi:',oldVal)
                //深度监听，同时也可监听到param参数变化
                let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
                this.PhaseID = params.phaseID;
                this.PhaseName = params.phaseName;
                // console.log(params)
            },
            deep: true,
        }
    },
    computed: {
        // 读取和设置
        // aPlus: {
        //     get: function () {
        //         return console.log(this.PhaseID)
        //     },
        // // set: function (v) {
        // //     this.a = v - 1
        // // }
        // }
    },
    created(){
        // console.log(this.$UrlEncode.decode(this.$route.query.key))
        let params = JSON.parse(this.$UrlEncode.decode(this.$route.query.key))
        this.my_data = params;
        this.PhaseID = params.phaseID;
        this.PhaseName = params.phaseName;
        // console.log(params)
        this.GetSportTeamList(this.my_data.EventID)//获取队伍列表
    },
    mounted(){
        // this.PhaseID = this.$cookie.get('PhaseID');
        this.GetMatchResultList(this.PhaseID,this.TeamValue)//获取比赛成绩列表
    },
    beforeUpdate(){
        // console.log(this.PhaseID)
        // console.log(this.$cookie.get('PhaseID'))
    },
    methods: {
        TableRowClassName({row, rowIndex}) {
            if ((rowIndex+1)%2==0) {
                return 'statistics-warning-row';
            } else {
                return '';
            }
        },
        handleChange(value){//选择队伍的下拉
            // console.log(value)
            this.TeamValue = value;
            this.GetMatchResultList(this.PhaseID,value)//获取比赛成绩列表
        },
        handleGroup(val,index){//点击上面的组别
            this.active = index;
            for(let i = 0; i < this.PhaseArr.length;i++){
                let item = this.PhaseArr[i];
                if(val == item.PhaseID){
                    this.RoundArr = item.RoundMatchList;
                }
            }
        },
        GetMatchResultList(PhaseID,TeamID){//获取比赛成绩列表
            http.GetMatchResultList(PhaseID,TeamID).then(res=>{////获取比赛成绩列表
                console.log(res)
                if(res.Status == 1){
                    // this.JsonData = res.DataResult;
                    if(res.DataResult.length > 0){ 
                        this.PhaseArr = res.DataResult;
                        this.RoundArr = this.PhaseArr[0].RoundMatchList;
                    }else{
                        this.PhaseArr = [];
                        this.$message.error('暂无数据啦');
                    }
                    
                }else if(res.Status == 0){
                    this.$message.error({message:'暂无数据!',duration: 1500,showClose: true,});
                }else{
                    this.$message.error({
                        message:'获取信息失败!',
                        duration: 1500,
                        showClose: true,
                    });
                }
            })
        },
        GetSportTeamList(EventID){//获取队伍列表
            http.GetSportTeamList(EventID).then(res=>{////获取队伍列表
                // console.log(res)
                if(res.Status == 1){
                    // this.JsonData = res.DataResult;
                    if(res.DataResult.length > 0){ 
                        this.TeamArr = res.DataResult;
                        this.TeamValue = res.DataResult[0].TeamID;
                        // this.RoundArr = this.PhaseArr[0].RoundMatchList;
                    }else{
                        this.TeamArr = [];
                        this.$message.error({
                            message:'暂无更多队伍!',
                            duration: 2000
                        });
                    }
                    
                }else if(res.Status == 0){
                    this.$message.error({message:'暂无数据!',duration: 1500,showClose: true,});
                }else{
                    this.$message.error({
                        message:'获取队伍信息失败!',
                        duration: 1500,
                        showClose: true,
                    });
                }
            })
        },

    }
}
</script>
<style lang="scss" scoped>
    ::v-deep .el-table__row.statistics-warning-row {
        background: #ddd;
    }
    ::v-deep .el-card__body{
        padding: 0;
    }
    .GameMatch{
        max-width: 1200px;
        margin: 20px auto;
        font-size: 16px;
    }
    .GameMatch_header{
        width: 100%;
        display: flex;
        align-items: center;
        justify-content: space-between;
    }
    .GameMatch_box{
        width: 100%;
    }
    .GameMatch_box_data{
        margin-top: 20px;
    }
    .activeCLass{
        color: #409EFF;
        background-color: #ecf5ff;
        border-color: #c6e2ff; 
        // outline-color: rgb(64, 158, 255); 
    }
    // .padding_obe{
    //     // padding-left: 15px;
    // }
    .font_s{
        font-style:oblique ;
    }
    .font_w{
        font-weight: bold;
        text-align: center;
    }
    .font_si{
        font-size: 20px;
    }
    .text_c{
        text-align: center;
    }
    
</style>